import IndigoApi, { JwtLoginOptions } from 'communication/IndigoApi';
import LoginResponse from 'communication/LoginResponse';
import RequestProgressService from 'requestProgress/RequestProgressService';
import { ApiRequestOptions } from 'communication/ApiCallInfo';

interface LoginServiceOptions {
    indigoApi: IndigoApi;
    requestProgressService: RequestProgressService;
}

export default class LoginService {
    private indigoApi: IndigoApi;
    private requestProgressService: RequestProgressService;

    public constructor(options: LoginServiceOptions) {
        this.indigoApi = options.indigoApi;
        this.requestProgressService = options.requestProgressService;
    }

    public async login(
        username: string,
        password: string
    ): Promise<LoginResponse> {
        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.login(username, password, options);
        return await this.requestProgressService.invokeAndMonitorRequest(
            'login',
            apiCall
        );
    }

    public async loginWithKey(key: string): Promise<LoginResponse> {
        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.loginKey(key, options);
        return await this.requestProgressService.invokeAndMonitorRequest(
            'loginKey',
            apiCall
        );
    }

    public async loginWithJwtToken(
        jwtLoginOptions: JwtLoginOptions
    ): Promise<LoginResponse> {
        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.loginJwt(jwtLoginOptions, options);
        return await this.requestProgressService.invokeAndMonitorRequest(
            'loginJwt',
            apiCall
        );
    }

    public async logout() {
        await this.indigoApi.logout();
    }
}
